import { z } from 'zod'

const DEFAULT_API_TIMEOUT = 10000

const envSchema = z.object({
  DEV: z.boolean().default(true),
  VITE_API_URL: z.url().default('http://localhost:3001/api'),
  VITE_API_TIMEOUT: z.coerce.number().default(DEFAULT_API_TIMEOUT),
  VITE_SENTRY_DSN: z.string().optional(),
})

export type Env = z.infer<typeof envSchema>

function validateEnv(): Env {
  const parsed = envSchema.safeParse(import.meta.env)

  if (!parsed.success) {
    console.error('❌ Invalid environment variables:')
    console.error(parsed.error.issues)
    throw new Error('Invalid environment variables')
  }

  return parsed.data
}

export const env = validateEnv()
